import React from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { Button, Card, CardActions, CardContent, CardHeader, IconButton, Slide } from "@material-ui/core";
import { createMarkup, masterHandleClose, remoteURL } from "../common";
import "../styles/masterStyles.css";

const MessageBanner = props => { 
    let classes = 'aua-top-banner anchor active index100';
    let direction = 'down';
    if (typeof props.direction === 'undefined') {
        direction = props.direction;
    }

    if (typeof props.data === 'object' && props.data !== null) {
        return (
            <Slide mountOnEnter unmountOnExit
                direction={direction}
                in={true}
                id="MessageBanner"
                className="aua-top-banner anchor active "
            >
                <Card >
                    <CardHeader 
                        title={props.data.title}
                        subheader={props.data.text}
                        action={
                            <IconButton
                                className="firstButton"
                                edge="start"
                                aria-label="firstIcon"
                                onClick={() => {
                                    if (typeof props.data.messageday !== 'undefined') {
                                        masterHandleClose('MessageBanner', 'active', 'inactive', 'sasp-messageday-id', props.data.messageday);
                                    }
                                    return masterHandleClose('MessageBanner', 'active', 'inactive', 'sasp-messageid', props.data.messageid);
                                }}
                                style={{backgroundColor: '#00567a', transform:"scale(0.5)"}}
                            >
                                <CloseIcon className="headerIcons" />
                            </IconButton>
                        }
                    />

                    {typeof props.data.summary !== 'undefined'
                        ? (
                            <>
                                <CardContent>
                                    <div dangerouslySetInnerHTML={createMarkup(props.data.summary)} />
                                </CardContent>

                                <CardActions>
                                    <Link 
                                        to={'/home'}
                                    >
                                        <Button 
                                            size="small"
                                        >
                                            Return Home   
                                        </Button>
                                    </Link>
                                </CardActions>
                            </>
                        ) : null
                    }

                    {typeof props.data.uri !== 'undefined'
                        ? (
                            <CardActions>
                                <Link 
                                    onClick={() => {
                                        masterHandleClose('MessageBanner', 'active', 'inactive', 'sasp-messageid', props.data.messageid)

                                        if (typeof props.data.uri !== 'undefined') {
                                            return remoteURL(props.data.uri)
                                        } 
            
                                        return null;
                                    }}
                                >
                                    <Button 
                                        size="small"
                                    >
                                        {props.data.actiontext ? props.data.actiontext : 'Learn More' }    
                                    </Button>
                                </Link>
                            </CardActions>
                        ) : null
                    }
                </Card>
            </Slide>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    return { auth, user_details };
};

const MessageBannerCard = connect(mapStateToProps)(withRouter(MessageBanner));

export { MessageBannerCard }
